import { useRouter } from 'next/router';

import { ForSaleFiltersVariant } from './ForSaleFilters.variant';
import { ToRentFiltersVariant } from './ToRentFilters.variant';

const filters = {
    'for-sale': ForSaleFiltersVariant,
    'to-rent': ToRentFiltersVariant,
    'new-homes': ForSaleFiltersVariant
};

const getFiltersComponent = (path: string) => {
    const pathRegex = /for-sale|to-rent|new-homes/;

    const searchType = path.match(pathRegex);

    if (searchType) {
        return filters[searchType[0] as keyof typeof filters];
    }

    return filters['for-sale'];
};

export const FiltersVariant = ({
    container
}: {
    container: HTMLElement | null;
}) => {
    const { pathname } = useRouter();

    const Component = getFiltersComponent(pathname);

    return <Component container={container} />;
};
